import { createSlice } from "@reduxjs/toolkit";
import _ from 'lodash';

const initialState = {
    Enumber: "",
    foodCategoryNumber: "",
    isShowFootnote: "",
}

const searchConditionSlice = createSlice({
    name: "searchCondition",
    initialState,
    reducers: {
        setSearchCondition: (state, action) => {
            state.Enumber = action.payload.Enumber;
            state.foodCategoryNumber = action.payload.foodCategoryNumber;
            state.isShowFootnote = action.payload.isShowFootnote;

        },
    },
});

export const { setSearchCondition } = searchConditionSlice.actions;
export default searchConditionSlice.reducer;